import React, {FC} from 'react';

import {PrescriptionV2} from 'api/magento/magentoAPI.schemas';

import style from '../../baseProductItems.scss';

export type PropsType = {
    prescription?: PrescriptionV2;
};

/**
 * Color block of CL cart component
 */
export const BaseLensesColorBlock: FC<PropsType> = ({prescription}) => {
    const areLensesInSameColor = prescription?.od?.color === prescription?.os?.color;
    const isColored = Boolean(prescription?.od?.color || prescription?.os?.color);

    return isColored ? (
        <p aria-label="CL color block" className={style.color}>
            {!areLensesInSameColor && <span>{prescription?.od?.color},</span>}{' '}
            {prescription?.os?.color && <span>{prescription?.os.color}</span>}
        </p>
    ) : null;
};
